// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1fBOq","header":"PatientBlock_header__2GpJj","label":"PatientBlock_label__2lmt_","option":"PatientBlock_option__3xQOm"};